import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const WeOfferArea = styled.section`
  padding: 100px 20px;
  background: #062c3f;
  min-height: 100vh;
  font-family: "Poppins", system-ui;

  @media (max-width: 768px) {
    padding: 80px 15px;
  }

  @media (max-width: 576px) {
    padding: 60px 10px;
  }
`;

const Container = styled.div`
  .container {
    font-family: "Poppins", system-ui;
  }
`;

const SiteHeading = styled.div`
  text-align: left;
  overflow: hidden;
  margin-top: -5px;

  h4 {
    display: block;
    font-size: 3em;

    margin-bottom: 10px;
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-style: normal;
    position: relative;
    z-index: 1;
    color: #00cbf1;

    span {
      color: #f0faff;
    }
  }

  p {
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 1.1em;
    color: #f0faff;
    margin: 1em 0 2em 0;
  }

  @media (max-width: 768px) {
    text-align: left;

    h4 {
      font-size: 2.5rem;
    }

    p {
      font-size: 1rem;
    }
  }

  @media (max-width: 576px) {
    h4 {
      font-size: 2rem;
    }

    p {
      font-size: 1rem;
      text-align: justify;
    }
  }
`;

const Item = styled.div`
  background: #ffffff none repeat scroll 0 0;
  box-shadow: 0 0 10px #cccccc;
  overflow: hidden;
  padding: 30px;
  position: relative;
  border-radius: 10px;
  z-index: 1;
  margin-bottom: 30px;

   &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  }

  i {
    color: #07b6f2;
    display: inline-block;
    font-size: 60px;
    margin-bottom: 20px;
    transition: all 0.35s ease-in-out;
  }

  h4 {
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    font-size: 1.2em;
    font-style: normal;
    color: #06334b;
  }

  p {
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 0.92em;
    color: #777777;
    margin-top: 1.2rem;
 
    line-height: 1.71;
    text-align: justify;
    hyphens: auto;
    transition: all 0.35s ease-in-out;
  }

  @media (max-width: 768px) {
    padding: 20px;

    i {
      font-size: 50px;
    }

    h4 {
      font-size: 1.5rem;
    }

    p {
      font-size: 0.9rem;
    }
  }

  @media (max-width: 576px) {
    padding: 15px;

    i {
      font-size: 40px;
    }

    h4 {
      font-size: 1.2em;
    }

    p {
      font-size: 0.91em;
      line-height: 1.71;
      color: #777777;
    }
  }
`;

const Solutions = () => {
  
    const navigate = useNavigate();
  
    const handleNavigation = (path) => {
      navigate(path);
    };

  return (
    <WeOfferArea className="we-offer-area text-center">
      <Container className="container">
        <div className="row">
          <div className="col-md-12">
            <SiteHeading className="site-heading">
              <h4>
                Our <span>Solutions</span>
              </h4>
              <p>
                We provide a wide range of solutions to help our customers to
                grow their business.{" "}
              </p>
            </SiteHeading>
          </div>
        </div>
        <div className="row our-offer-items less-carousel">
          {/* Single Item */}
          
          <div className="col-md-4 col-sm-6 equal-height">
          <Item className="item" onClick={() => handleNavigation("/teamcenter/implementation")}>
              <i className="fas fa-project-diagram"></i>
              <h4 className="site-subheading">PLM Implementation</h4>
              <p>
                We offer a complete lifecycle of Teamcenter product suite
                implementation services to our customers across diverse.
              </p>
            </Item>
          </div>
          {/* End Single Item */}
          {/* Single Item */}
          <div className="col-md-4 col-sm-6 equal-height">
            <Item className="item" onClick={() => handleNavigation("/polarion-alm-solution")}>
              <i className="fas fa-tools"></i>
              <h4 className="site-subheading">Polarion ALM Solutions</h4>
              <p>
                We offer Polarian implementation services that enable you to
                manage a complete software development management.
              </p>
            </Item>
          </div>
          {/* End Single Item */}
          {/* Single Item */}
          <div className="col-md-4 col-sm-6 equal-height">
          <Item className="item" onClick={() => handleNavigation("/mendix-apps-solutions")}>
              <i className="fas fa-mobile-alt"></i>
              <h4 className="site-subheading">Mendix APP Solutions</h4>
              <p>
                We offer solutions to different business requirements such as
                innovative, legacy, Customer Facing, Operational Efficiency.
              </p>
            </Item>
          </div>
          {/* End Single Item */}
          {/* Single Item */}
          <div className="col-md-4 col-sm-6 equal-height">
          <Item className="item" onClick={() => handleNavigation("/teamcenter/aw-client")}>
              <i className="fas fa-cogs"></i>
              <h4 className="site-subheading">AWC Customization</h4>
              <p>
                We offer Active Workspace Client customization that enhances
                user experience across devices, enabling seamless PLM access in
                preferred environments like NX, Vis, and MSO, with an intuitive
                UI for immediate productivity.
              </p>
            </Item>
          </div>
          {/* End Single Item */}
          {/* Single Item */}
          <div className="col-md-4 col-sm-6 equal-height">
          <Item className="item" onClick={() => handleNavigation("/teamcenter/staff-augmentation-services")}>
              <i className="fas fa-users"></i>
              <h4 className="site-subheading"> Staff Augmentation</h4>
              <p>
                We assist customers in swiftly building and operationalizing
                offshore teams, focusing on PLM and staff augmentation services.
                Our expertise ensures seamless integration and efficient
                delivery, driving value for your business.
              </p>
            </Item>
          </div>
          {/* End Single Item */}
          {/* Single Item */}
          <div className="col-md-4 col-sm-6 equal-height">
          <Item className="item" onClick={() => handleNavigation("/teamcenter/software-development-services")}>
              <i className="fas fa-code"></i>
              <h4 className="site-subheading">Software Development</h4>
              <p>
              We develop custom software that enhances automation, improving operational efficiency. Our solutions adhere to international standards, ensuring robustness & reliability. This approach delivers long-term value to your business.
              </p>
            </Item>
          </div>
          {/* End Single Item */}
        </div>
      </Container>
    </WeOfferArea>
  );
};

export default Solutions;
